<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll">
        <!-- Security Badge and Navigation -->
        <div class="top-section py-3">
            <div class="row align-items-center">
                <!-- Security Badge -->
                <div class="col-md-3 col-12 mb-3 mb-md-0">
                    <div class="security-badge">
                        <!-- <i class="fas fa-shield-alt security-icon"></i>
                        <span class="security-text">This is a secured connection</span> -->
                    </div>
                </div>

                <!-- Navigation Tabs -->
                <div class="col-md-6 col-12 mb-3 mb-md-0">
                    <div class="nav-tabs-container">
                        <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab" [class.active]="activeTab === 'number'" (click)="setTab('number')">
                            <i class="fas fa-phone custom-icon"></i>
                            <span>By Number</span>
                        </button>
                        <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab" [class.active]="activeTab === 'email'" (click)="setTab('email')">
                            <i class="fas fa-envelope custom-icon"></i>
                            <span>By Email</span>
                        </button>
                        <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab" [class.active]="activeTab === 'username'" (click)="setTab('username')">
                            <i class="fas fa-user custom-icon"></i>
                            <span>By Username</span>
                        </button>
                        <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab" [class.active]="activeTab === 'password'" (click)="setTab('password')">
                            <i class="fas fa-lock custom-icon"></i>
                            <span>By Password</span>
                        </button>
                    </div>
                </div>

                <!-- Credits Display -->
                <div class="col-md-3 col-12">
                    <div class="credits-display">
                        <span class="credits-label">Remaining</span>
                        <div class="credits-value">
                            <i class="fas fa-coins credits-icon"></i>
                            <strong><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></strong>
                        </div>
                        <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">Buy Credits</button>
                        <!-- <app-search-help-link></app-search-help-link> -->
                    </div>
                </div>
            </div>

            <!-- Restricted Access Alert -->
            <div class="restricted-alert" appRestrictedAccessWarning>
                <i class="fas fa-exclamation-circle alert-icon"></i>
                <span class="alert-text">
                    <span class="alert-restricted">RESTRICTED ACCESS!</span>
                    <span class="alert-authorized">Authorized Law Enforcement Use Only.</span>
                </span>
            </div>
            <p class="credit-cost-notice" *ngIf="searchCreditCost != null">
                Each search costs <strong>{{ searchCreditCost }}</strong>
                {{ searchCreditCost === 1 ? 'credit' : 'credits' }}. If no results are found credits will be refunded.
            </p>
        </div>

        <!-- Service Disabled Warning -->
        <div class="search-card-container" *ngIf="isServiceDisabled">
            <div class="service-disabled-warning">
                <div class="warning-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <h2 class="warning-title">Search temporarily unavailable</h2>
                <p class="warning-message">
                    We're experiencing a temporary service issue. You can still access and export your previous search history below.
                </p>
            </div>
        </div>

        <!-- Search Card -->
        <div class="search-card-container" *ngIf="!isServiceDisabled">
            <div class="search-card">
                <h2 class="search-title">Search Email</h2>

                <!-- Single Email Search -->
                <div class="search-input-container d-flex flex-row">
                    <div class="email-input-group w-100">
                        <input type="text" class="email-input" placeholder="e.g. john@example.com" [(ngModel)]="singleEmail">

                    </div>
                    <button class="search-button rounded" (click)="onSearchSingleEmailButtonClick()">
                        Search
                    </button>
                </div>

                <p class="single-line-text">
                    Each search costs 1 credit. If no results are found credits will be refunded.
                </p>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="loadingJobIds || loadingRecentResults">
            <div class="spinner-border" role="status"></div>
            <p class="loading-text">Fetching results, please wait...</p>
        </div>

        <!-- Results Section -->
        <div class="results-section mt-3">
            <div class="card">
                <div class="card-body p-4">

                    <div class="results-controls">
                        <!-- Filter Controls -->
                        <div class="filter-section">
                            <select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                                <option *ngFor="let filterType of filterTypes" [value]="filterType.value">
                                    {{ filterType.label }}
                                </option>
                            </select>
                            <div class="filter-input-container">
                                <input *ngIf="selectedFilterType === 'email'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="emailFilter" (ngModelChange)="onEmailFilterChange($event)">

                                <input *ngIf="selectedFilterType === 'notes'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="notesFilter" (ngModelChange)="onNotesFilterChange($event)">

                                <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'">
                                    <input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter" (ngModelChange)="onStartDateFilterChange($event)">
                                    <input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter" (ngModelChange)="onEndDateFilterChange($event)">
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="action-buttons">
                            <!-- 
                            <button class="action-btn export-btn" (click)="onExportExcelButtonClick()">
                                <i class="fas fa-file-excel"></i>
                                Export Excel
                            </button>
                            <button class="action-btn export-btn" (click)="onExportCsvButtonClick()">
                                <i class="fas fa-file-csv"></i>
                                Export CSV
                            </button>
                            <button class="action-btn export-btn" (click)="onExportPdfButtonClick()">
                                <i class="fas fa-file-pdf"></i>
                                Export PDF
                            </button>

                            -->
                            <button class="action-btn delete-btn" (click)="onDeleteButtonClick()">
                                <i class="fas fa-trash"></i>
                                Delete
                            </button>
                        </div>
                    </div>

                    <!-- Results Table -->
                    <div class="results-table-container">
                        <table class="results-table">
                            <thead>
                                <tr>
                                    <th class="checkbox-column">
                                        <input type="checkbox" class="table-checkbox" [checked]="recentResultsSelectAll.isSelected" (change)="onRecentResultsSelectAllClick()">
                                    </th>
                                    <th>Email</th>
                                    <th>Status</th>
                                    <th>Date Added</th>
                                    <th>Time</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let recentResultPaged of recentResultsPaged" class="table-row">
                                    <td class="checkbox-column">
                                        <input type="checkbox" class="table-checkbox" [checked]="recentResultPaged.isSelected" (click)="onRecentResultPagedClick($event, recentResultPaged)">
                                    </td>
                                    <td class="email-column" (click)="goToSearchResultPage(recentResultPaged)">
                                        {{ recentResultPaged.query }}
                                    </td>
                                    <td class="status-column">
                                        <span class="status-badge" [class.status-completed]="recentResultPaged.done" [class.status-pending]="!recentResultPaged.done">
                                            {{ recentResultPaged.done ? 'Completed' : 'Pending' }}
                                        </span>
                                    </td>
                                    <td class="date-column">
                                        {{ recentResultPaged.created_on | date : 'MMM d, y' }}
                                    </td>
                                    <td class="time-column">
                                        {{ recentResultPaged.created_on | date : 'HH:mm:ss' }}
                                    </td>
                                    <td class="notes-column">
                                        {{ recentResultPaged.notes || '-' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Pagination -->
                    <div class="pagination-container">
                        <div class="pagination-info">
                            Showing {{ recentResultsPagedStartAndEnd.start }} of {{ recentResultsCount }} result
                        </div>
                        <div class="pagination-controls">
                            <app-paginator [totalItems]="recentResultsCount" [itemsPerPage]="recentResultsPerPage" [currentPage]="recentResultsCurrentPage" (pageChange)="onRecentResultsPageChange($event)">
                            </app-paginator>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>